var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SectionHeader", {
    attrs: {
      "show-content": _vm.defaultPassThroughBidShowContents,
      "widget-title": _vm.$t("HEADER_DEFAULT_PASSTHROUGH_SETTINGS")
    },
    on: {
      onShowContentsClick: function($event) {
        return _vm.onDefaultPassThroughBidShowContentsClick()
      }
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function() {
          return [
            _c(
              "form",
              {
                staticClass: "form-horizontal",
                attrs: { role: "form", name: "vm.campaignForm" }
              },
              [
                _vm.overridesAvailable &&
                _vm.currentPassThroughBid && _vm.currentPassThroughBid.enabled
                  ? _c(
                      "div",
                      [
                        _c("Field", {
                          attrs: {
                            label: _vm.$t(
                              "LABEL_OVERRIDE_DEFAULT_PASSTHROUGH_SETTINGS"
                            ),
                            "hide-label": false,
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t(
                              "TOOLTIP_OVERRIDE_DEFAULT_PASSTHROUGH_SETTINGS"
                            )
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "p-l-0 col-sm-5 col-md-1"
                                      },
                                      [
                                        _c(
                                          "ValidationProvider",
                                          { attrs: { slim: "" } },
                                          [
                                            _c("nzToggle", {
                                              attrs: {
                                                "data-cy":
                                                  "default-passthrough-settings-overide-toggle"
                                              },
                                              on: {
                                                onToggle:
                                                  _vm.overrideDefaultPassThroughBidToggle
                                              },
                                              model: {
                                                value:
                                                  _vm.overrideDefaultPassThroughBid,
                                                callback: function($$v) {
                                                  _vm.overrideDefaultPassThroughBid = $$v
                                                },
                                                expression:
                                                  "overrideDefaultPassThroughBid"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            271836338
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.overridesAvailable &&
                _vm.currentPassThroughBid && !_vm.currentPassThroughBid.enabled
                  ? _c("p", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "PASSTHROUGH_INTRO_FOR_DISABLED_PUB",
                          expression: "'PASSTHROUGH_INTRO_FOR_DISABLED_PUB'"
                        }
                      ]
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.overridesAvailable || _vm.overrideDefaultPassThroughBid
                  ? _c(
                      "div",
                      [
                        !_vm.overridesAvailable
                          ? _c("Field", {
                              attrs: {
                                label: _vm.$t(
                                  "LABEL_ENABLE_PASSTHROUGH_SETTINGS"
                                ),
                                "hide-label": false,
                                "has-tooltip": true,
                                "tooltip-text": _vm.$t(
                                  "TOOLTIP_ENABLE_PASSTHROUGH_SETTINGS"
                                )
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "element",
                                    fn: function() {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "p-l-0 col-sm-5 col-md-1"
                                          },
                                          [
                                            _c(
                                              "ValidationProvider",
                                              { attrs: { slim: "" } },
                                              [
                                                _c("nzToggle", {
                                                  attrs: {
                                                    "data-cy":
                                                      "default-passthrough-bid-toggle"
                                                  },
                                                  on: {
                                                    onToggle:
                                                      _vm.enablePassThroughBidToggle
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.passThroughBid
                                                        .enabled,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.passThroughBid,
                                                        "enabled",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "passThroughBid.enabled"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                2477573517
                              )
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentPassThroughBid.enabled ||
                        (_vm.overrideDefaultPassThroughBid &&
                          _vm.currentPassThroughBid.enabled)
                          ? _c(
                              "div",
                              [
                                _c("Field", {
                                  attrs: {
                                    label: _vm.$t("LABEL_MAX_BID"),
                                    "hide-label": false,
                                    "has-tooltip": true,
                                    "tooltip-text": _vm.$t("TOOLTIP_MAX_BID")
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "element",
                                        fn: function() {
                                          return [
                                            _c("ValidationProvider", {
                                              attrs: {
                                                rules:
                                                  "required|min_value:0.01",
                                                slim: ""
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({
                                                      classes,
                                                      errors
                                                    }) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "p-l-0 col-sm-5 col-md-1"
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .passThroughBid
                                                                      .maxBid,
                                                                  expression:
                                                                    "passThroughBid.maxBid"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              class: classes,
                                                              attrs: {
                                                                name: "maxBid",
                                                                "data-cy":
                                                                  "passThroughMaxBid",
                                                                required: true,
                                                                type: "number"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .passThroughBid
                                                                    .maxBid
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.updatePassThroughBid,
                                                                wheel: function(
                                                                  $event
                                                                ) {
                                                                  return $event.target.blur()
                                                                },
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  )
                                                                    return
                                                                  _vm.$set(
                                                                    _vm.passThroughBid,
                                                                    "maxBid",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        errors[0]
                                                          ? _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form-group__label-required vv-invalid",
                                                                attrs: {
                                                                  name:
                                                                    "passThroughMaxBid-invalid-label",
                                                                  "data-cy":
                                                                    "passThroughMaxBid-invalid-label"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "ERROR_MAX_BID_AMOUNT"
                                                                    )
                                                                  ) +
                                                                    "\n                "
                                                                )
                                                              ]
                                                            )
                                                          : _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form-group__label-required"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "REQUIRED"
                                                                    )
                                                                  ) +
                                                                    "\n                "
                                                                )
                                                              ]
                                                            )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                570338643
                                              )
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    2745977227
                                  )
                                }),
                                _vm._v(" "),
                                _c("Field", {
                                  attrs: {
                                    label: _vm.$t("LABEL_ALLOW_BIDS_AT_LOSS"),
                                    "hide-label": false,
                                    "has-tooltip": true,
                                    "tooltip-text": _vm.$t(
                                      "TOOLTIP_ALLOW_BIDS_AT_LOSS"
                                    )
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "element",
                                        fn: function() {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "p-l-0 col-sm-5 col-md-1"
                                              },
                                              [
                                                _c(
                                                  "ValidationProvider",
                                                  { attrs: { slim: "" } },
                                                  [
                                                    _c("nzToggle", {
                                                      attrs: {
                                                        "data-cy":
                                                          "passThroughAllowBidsAtLoss"
                                                      },
                                                      on: {
                                                        onToggle: function(
                                                          $event
                                                        ) {
                                                          return _vm.allowBidsAtLossToggle(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.passThroughBid
                                                            .allowBidsAtLoss,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.passThroughBid,
                                                            "allowBidsAtLoss",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "passThroughBid.allowBidsAtLoss"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    4052511146
                                  )
                                }),
                                _vm._v(" "),
                                _c("Field", {
                                  attrs: {
                                    label: _vm.$t("LABEL_PASS_THROUGH_TYPE"),
                                    "hide-label": false,
                                    "has-tooltip": false
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "element",
                                        fn: function() {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "p-l-0 col-sm-6 col-md-6"
                                              },
                                              [
                                                _c(
                                                  "ValidationProvider",
                                                  { attrs: { slim: "" } },
                                                  [
                                                    _c("MultipleToggle", {
                                                      attrs: {
                                                        "data-cy":
                                                          "passThroughBidMarginType",
                                                        value:
                                                          _vm.passThroughBidType,
                                                        options:
                                                          _vm.passThroughBidTypeOptions
                                                      },
                                                      on: {
                                                        onToggle: function(
                                                          $event
                                                        ) {
                                                          return _vm.passThroughBidTypeChange(
                                                            $event
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    1910548481
                                  )
                                }),
                                _vm._v(" "),
                                _vm.passThroughBidType === "percentage"
                                  ? [
                                      _c("Field", {
                                        attrs: {
                                          label: _vm.$t(
                                            "LABEL_BID_MARGIN_PERCENTAGE"
                                          ),
                                          "hide-label": false,
                                          "has-tooltip": true,
                                          "tooltip-text": _vm.$t(
                                            "TOOLTIP_BID_MARGIN_PERCENTAGE"
                                          )
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "element",
                                              fn: function() {
                                                return [
                                                  _c("ValidationProvider", {
                                                    attrs: {
                                                      rules: "min_value:0",
                                                      slim: ""
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function({
                                                            classes,
                                                            errors
                                                          }) {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "p-l-0 col-sm-5 col-md-1"
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm
                                                                            .passThroughBid
                                                                            .bidMarginPercentage,
                                                                        expression:
                                                                          "passThroughBid.bidMarginPercentage"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "form-control text-align-right",
                                                                    class: classes,
                                                                    attrs: {
                                                                      name:
                                                                        "bidMarginPercentage",
                                                                      "data-cy":
                                                                        "passThroughBidMarginPercentage",
                                                                      required: false,
                                                                      placeholder: _vm.$t(
                                                                        "LABEL_PLACEHOLDER_MIN_BID_MARGIN_PERCENTAGE"
                                                                      ),
                                                                      type:
                                                                        "number"
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm
                                                                          .passThroughBid
                                                                          .bidMarginPercentage
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        _vm.updatePassThroughBid,
                                                                      wheel: function(
                                                                        $event
                                                                      ) {
                                                                        return $event.target.blur()
                                                                      },
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        )
                                                                          return
                                                                        _vm.$set(
                                                                          _vm.passThroughBid,
                                                                          "bidMarginPercentage",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    }
                                                                  })
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              errors[0]
                                                                ? _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "form-group__label-required vv-invalid",
                                                                      attrs: {
                                                                        name:
                                                                          "passThroughBidMarginPercentage-invalid-label",
                                                                        "data-cy":
                                                                          "passThroughBidMarginPercentage-invalid-label"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "ERROR_GREATER_THAN_OR_EQUAL"
                                                                          )
                                                                        ) +
                                                                          "\n                  "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      3892056739
                                                    )
                                                  })
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          false,
                                          2435660948
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c("Field", {
                                        attrs: {
                                          label: _vm.$t(
                                            "LABEL_MIN_BID_MARGIN_PERCENTAGE_AFTER_ADJUSTMENTS"
                                          ),
                                          "hide-label": false,
                                          "has-tooltip": true,
                                          "tooltip-text": _vm.$t(
                                            "TOOLTIP_MIN_BID_MARGIN_PERCENTAGE_AFTER_ADJUSTMENTS"
                                          )
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "element",
                                              fn: function() {
                                                return [
                                                  _c("ValidationProvider", {
                                                    attrs: {
                                                      rules: "min_value:0",
                                                      slim: ""
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function({
                                                            classes,
                                                            errors
                                                          }) {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "p-l-0 col-sm-5 col-md-1"
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm
                                                                            .passThroughBid
                                                                            .minBidMarginPercentageAfterAdjustments,
                                                                        expression:
                                                                          "passThroughBid.minBidMarginPercentageAfterAdjustments"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "form-control text-align-right",
                                                                    class: classes,
                                                                    attrs: {
                                                                      name:
                                                                        "minBidMarginPercentageAfterAdjustments",
                                                                      "data-cy":
                                                                        "passThroughMinBidMarginPercentageAfterAdjustments",
                                                                      required: false,
                                                                      placeholder: _vm.$t(
                                                                        "LABEL_PLACEHOLDER_MIN_BID_MARGIN_PERCENTAGE_AFTER_ADJUSTMENTS"
                                                                      ),
                                                                      type:
                                                                        "number"
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm
                                                                          .passThroughBid
                                                                          .minBidMarginPercentageAfterAdjustments
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        _vm.updatePassThroughBid,
                                                                      wheel: function(
                                                                        $event
                                                                      ) {
                                                                        return $event.target.blur()
                                                                      },
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        )
                                                                          return
                                                                        _vm.$set(
                                                                          _vm.passThroughBid,
                                                                          "minBidMarginPercentageAfterAdjustments",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    }
                                                                  })
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              errors[0]
                                                                ? _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "form-group__label-required vv-invalid",
                                                                      attrs: {
                                                                        name:
                                                                          "passThroughMinBidMarginPercentageAfterAdjustments-invalid-label",
                                                                        "data-cy":
                                                                          "passThroughMinBidMarginPercentageAfterAdjustments-invalid-label"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "ERROR_GREATER_THAN_OR_EQUAL"
                                                                          )
                                                                        ) +
                                                                          "\n                  "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      3280219163
                                                    )
                                                  })
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          false,
                                          2840645861
                                        )
                                      })
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.passThroughBidType === "amount"
                                  ? [
                                      _c("Field", {
                                        attrs: {
                                          label: _vm.$t(
                                            "LABEL_BID_MARGIN_AMOUNT"
                                          ),
                                          "hide-label": false,
                                          "has-tooltip": true,
                                          "tooltip-text": _vm.$t(
                                            "TOOLTIP_BID_MARGIN_AMOUNT"
                                          )
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "element",
                                              fn: function() {
                                                return [
                                                  _c("ValidationProvider", {
                                                    attrs: {
                                                      rules: "min_value:0",
                                                      slim: ""
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function({
                                                            classes,
                                                            errors
                                                          }) {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "p-l-0 col-sm-5 col-md-1"
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm
                                                                            .passThroughBid
                                                                            .bidMarginAmount,
                                                                        expression:
                                                                          "passThroughBid.bidMarginAmount"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "form-control text-align-right",
                                                                    class: classes,
                                                                    attrs: {
                                                                      name:
                                                                        "bidMarginAmount",
                                                                      "data-cy":
                                                                        "passThroughBidMarginAmount",
                                                                      required: false,
                                                                      placeholder: _vm.$t(
                                                                        "LABEL_PLACEHOLDER_MIN_BID_MARGIN_AMOUNT"
                                                                      ),
                                                                      type:
                                                                        "number"
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm
                                                                          .passThroughBid
                                                                          .bidMarginAmount
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        _vm.updatePassThroughBid,
                                                                      wheel: function(
                                                                        $event
                                                                      ) {
                                                                        return $event.target.blur()
                                                                      },
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        )
                                                                          return
                                                                        _vm.$set(
                                                                          _vm.passThroughBid,
                                                                          "bidMarginAmount",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    }
                                                                  })
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              errors[0]
                                                                ? _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "form-group__label-required vv-invalid",
                                                                      attrs: {
                                                                        name:
                                                                          "passThroughBidMarginAmount-invalid-label",
                                                                        "data-cy":
                                                                          "passThroughBidMarginAmount-invalid-label"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "ERROR_GREATER_THAN_OR_EQUAL"
                                                                          )
                                                                        ) +
                                                                          "\n                  "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      54457143
                                                    )
                                                  })
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          false,
                                          1831811407
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c("Field", {
                                        attrs: {
                                          label: _vm.$t(
                                            "LABEL_MIN_BID_MARGIN_AMOUNT_AFTER_ADJUSTMENTS"
                                          ),
                                          "hide-label": false,
                                          "has-tooltip": true,
                                          "tooltip-text": _vm.$t(
                                            "TOOLTIP_MIN_BID_MARGIN_AMOUNT_AFTER_ADJUSTMENTS"
                                          )
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "element",
                                              fn: function() {
                                                return [
                                                  _c("ValidationProvider", {
                                                    attrs: {
                                                      rules: "min_value:0",
                                                      slim: ""
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function({
                                                            classes,
                                                            errors
                                                          }) {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "p-l-0 col-sm-5 col-md-1"
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm
                                                                            .passThroughBid
                                                                            .minBidMarginAmountAfterAdjustments,
                                                                        expression:
                                                                          "passThroughBid.minBidMarginAmountAfterAdjustments"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "form-control text-align-right",
                                                                    class: classes,
                                                                    attrs: {
                                                                      name:
                                                                        "minBidMarginAmountAfterAdjustments",
                                                                      "data-cy":
                                                                        "passThroughMinBidMarginAmountAfterAdjustments",
                                                                      required: false,
                                                                      placeholder: _vm.$t(
                                                                        "LABEL_PLACEHOLDER_MIN_BID_MARGIN_AMOUNT_AFTER_ADJUSTMENTS"
                                                                      ),
                                                                      type:
                                                                        "number"
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm
                                                                          .passThroughBid
                                                                          .minBidMarginAmountAfterAdjustments
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        _vm.updatePassThroughBid,
                                                                      wheel: function(
                                                                        $event
                                                                      ) {
                                                                        return $event.target.blur()
                                                                      },
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        )
                                                                          return
                                                                        _vm.$set(
                                                                          _vm.passThroughBid,
                                                                          "minBidMarginAmountAfterAdjustments",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    }
                                                                  })
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              errors[0]
                                                                ? _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "form-group__label-required vv-invalid",
                                                                      attrs: {
                                                                        name:
                                                                          "passThroughMinBidMarginAmountAfterAdjustments-invalid-label",
                                                                        "data-cy":
                                                                          "passThroughMinBidMarginAmountAfterAdjustments-invalid-label"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "ERROR_GREATER_THAN_OR_EQUAL"
                                                                          )
                                                                        ) +
                                                                          "\n                  "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      3230908303
                                                    )
                                                  })
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          false,
                                          2213151509
                                        )
                                      })
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("Field", {
                                  attrs: {
                                    label: _vm.$t(
                                      "LABEL_MIN_BID_DURATION_SELECTION"
                                    ),
                                    "hide-label": false,
                                    "has-tooltip": true,
                                    "tooltip-text": _vm.$t(
                                      "TOOLTIP_MIN_BID_DURATION_SELECTION"
                                    )
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "element",
                                        fn: function() {
                                          return [
                                            _c("ValidationProvider", {
                                              attrs: {
                                                rules: "required",
                                                slim: ""
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ classes }) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "p-l-0 col-sm-4 col-md-3"
                                                          },
                                                          [
                                                            _c(
                                                              "SearchableDropdown",
                                                              {
                                                                staticClass:
                                                                  "rtb-default-selector m-b-10",
                                                                class: classes,
                                                                attrs: {
                                                                  name:
                                                                    "bidDuration",
                                                                  config:
                                                                    _vm.bidDurationDropdownConfig,
                                                                  searchable: false,
                                                                  clearable: false
                                                                },
                                                                on: {
                                                                  change:
                                                                    _vm.onBidDurationDropdownOnChange
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.selectedBidDuration,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.selectedBidDuration = $$v
                                                                  },
                                                                  expression:
                                                                    "selectedBidDuration"
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                4986069
                                              )
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    3484524973
                                  )
                                }),
                                _vm._v(" "),
                                _vm.bidDuration === "Custom"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm-offset-3 col-md-offset-3 col-md-3 col-sm-4 p-l-0"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "bs-callout bs-callout-sm bs-callout-warning"
                                            },
                                            [
                                              _c("p", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value:
                                                      "CUSTOM_BID_DURATION_WARNING",
                                                    expression:
                                                      "'CUSTOM_BID_DURATION_WARNING'"
                                                  }
                                                ]
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.bidDuration === "Static"
                                  ? [
                                      _c("Field", {
                                        attrs: {
                                          label: _vm.$t("LABEL_MIN_BID_STATIC"),
                                          "hide-label": false,
                                          "has-tooltip": true,
                                          "tooltip-text": _vm.$t(
                                            "TOOLTIP_MIN_BID_STATIC"
                                          )
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "element",
                                              fn: function() {
                                                return [
                                                  _c("ValidationProvider", {
                                                    attrs: {
                                                      rules:
                                                        "required|min_value:0.01",
                                                      slim: ""
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function({
                                                            classes,
                                                            errors
                                                          }) {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "p-l-0 col-sm-5 col-md-1"
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm.bidDurationAdjustmentAmount,
                                                                        expression:
                                                                          "bidDurationAdjustmentAmount"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "form-control text-align-right",
                                                                    class: classes,
                                                                    attrs: {
                                                                      name:
                                                                        "bidDurationAdjustmentAmount",
                                                                      "data-cy":
                                                                        "bidDurationAdjustmentAmount",
                                                                      required: false,
                                                                      type:
                                                                        "number"
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.bidDurationAdjustmentAmount
                                                                    },
                                                                    on: {
                                                                      input: [
                                                                        function(
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          )
                                                                            return
                                                                          _vm.bidDurationAdjustmentAmount =
                                                                            $event.target.value
                                                                        },
                                                                        _vm.updateBidDuration
                                                                      ],
                                                                      wheel: function(
                                                                        $event
                                                                      ) {
                                                                        return $event.target.blur()
                                                                      }
                                                                    }
                                                                  })
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("label", {
                                                                directives: [
                                                                  {
                                                                    name: "t",
                                                                    rawName:
                                                                      "v-t",
                                                                    value:
                                                                      "SECONDS_LABEL",
                                                                    expression:
                                                                      "'SECONDS_LABEL'"
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "m-t-10"
                                                              }),
                                                              _vm._v(" "),
                                                              errors[0]
                                                                ? _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "form-group__label-required vv-invalid",
                                                                      attrs: {
                                                                        name:
                                                                          "bidDurationAdjustmentAmount-invalid-label",
                                                                        "data-cy":
                                                                          "bidDurationAdjustmentAmount-invalid-label"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "ERROR_BID_STATIC_ADJUSTMENT_AMOUNT"
                                                                          )
                                                                        ) +
                                                                          "\n                  "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      3262168638
                                                    )
                                                  })
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          false,
                                          2042203002
                                        )
                                      })
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.bidDuration === "Adjusted"
                                  ? [
                                      _c("Field", {
                                        attrs: {
                                          label: _vm.$t("LABEL_MIN_BID_ADJUST"),
                                          "hide-label": false,
                                          "has-tooltip": true,
                                          "tooltip-text": _vm.$t(
                                            "TOOLTIP_MIN_BID_ADJUST"
                                          )
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "element",
                                              fn: function() {
                                                return [
                                                  _c("ValidationProvider", {
                                                    attrs: {
                                                      rules:
                                                        "required|min_value:0.01",
                                                      slim: ""
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function({
                                                            classes,
                                                            errors
                                                          }) {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "p-l-0 col-sm-5 col-md-1"
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm.bidDurationAdjustmentAmount,
                                                                        expression:
                                                                          "bidDurationAdjustmentAmount"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "form-control text-align-right",
                                                                    class: classes,
                                                                    attrs: {
                                                                      name:
                                                                        "bidDurationAdjustmentAmount",
                                                                      "data-cy":
                                                                        "bidDurationAdjustmentAmount",
                                                                      required: false,
                                                                      type:
                                                                        "number"
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.bidDurationAdjustmentAmount
                                                                    },
                                                                    on: {
                                                                      input: [
                                                                        function(
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          )
                                                                            return
                                                                          _vm.bidDurationAdjustmentAmount =
                                                                            $event.target.value
                                                                        },
                                                                        _vm.updateBidDuration
                                                                      ],
                                                                      wheel: function(
                                                                        $event
                                                                      ) {
                                                                        return $event.target.blur()
                                                                      }
                                                                    }
                                                                  })
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("label", {
                                                                directives: [
                                                                  {
                                                                    name: "t",
                                                                    rawName:
                                                                      "v-t",
                                                                    value:
                                                                      "SECONDS_LABEL",
                                                                    expression:
                                                                      "'SECONDS_LABEL'"
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "m-t-10"
                                                              }),
                                                              _vm._v(" "),
                                                              errors[0]
                                                                ? _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "form-group__label-required vv-invalid",
                                                                      attrs: {
                                                                        name:
                                                                          "bidDurationAdjustmentAmount-invalid-label",
                                                                        "data-cy":
                                                                          "bidDurationAdjustmentAmount-invalid-label"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "ERROR_BID_ADJUSTED_ADJUSTMENT_AMOUNT"
                                                                          )
                                                                        ) +
                                                                          "\n                  "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      1513153530
                                                    )
                                                  })
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          false,
                                          345317502
                                        )
                                      })
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }